import * as Yup from "yup";
import {TranslatedText} from "../../../helpers/helpers";
import React from "react";

export const initialValuesBillNumber = {
  codIdBolletta: '',
};
export const schemaBillNumber = Yup.object().shape({
  codIdBolletta: Yup.number()
    .typeError(<TranslatedText i18nKey="cases.allacciamento.step4_2.numero.placeholder" />)
  .required(
    <TranslatedText i18nKey="errors.amministratori_condominio.bill.required"/>
    ),
});
